import React from "react";

const SectionHeader = ({ eyebrow, title, action }) => (
  <div className="mb-8 flex items-end justify-between gap-4">
    <div>
      {eyebrow && (
        <p className="label-mono text-ink/50 mb-2">{eyebrow}</p>
      )}
      <h2 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none">
        {title}
      </h2>
    </div>
    {action}
  </div>
);

export default SectionHeader;
